import script from "./OrganizationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationsPage.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationsPage.vue?vue&type=style&index=0&id=9e9d7f40&scoped=true&lang=css"
script.__scopeId = "data-v-9e9d7f40"

export default script